import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Building2, Globe, Shield, Scale, Mail, Phone, MapPin } from "lucide-react";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        {/* En-tête */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Scale className="h-12 w-12 text-blue-600 mr-3" />
            <h1 className="text-4xl font-bold text-gray-900">Mentions Légales</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Informations légales et réglementaires concernant le site Balinaisa
          </p>
        </div>

        <div className="space-y-8">
          {/* 1. Éditeur du site */}
          <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-t-lg">
              <CardTitle className="flex items-center text-xl">
                <Building2 className="h-6 w-6 mr-3" />
                1. Éditeur du site
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6 space-y-4">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-3">
                  <h3 className="font-semibold text-lg text-blue-700">Balinaisa</h3>
                  <div className="space-y-2 text-gray-700">
                    <p><span className="font-medium">Forme juridique :</span> SAS</p>
                    <div className="flex items-start">
                      <MapPin className="h-4 w-4 mr-2 mt-1 text-blue-600" />
                      <div>
                        <span className="font-medium">Siège social :</span><br />
                        13 rue Anders Celsius<br />
                        33470 Le Teich, France
                      </div>
                    </div>
                    <div className="flex items-center">
                      <Phone className="h-4 w-4 mr-2 text-blue-600" />
                      <span><span className="font-medium">Téléphone :</span> 07 45 06 52 16</span>
                    </div>
                    <div className="flex items-center">
                      <Mail className="h-4 w-4 mr-2 text-blue-600" />
                      <span><span className="font-medium">Email :</span> contact@balinaisa.com</span>
                    </div>
                  </div>
                </div>
                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-800">Informations légales</h4>
                  <div className="space-y-2 text-gray-700">
                    <p><span className="font-medium">SIRET :</span> 948 801 808 00015</p>
                    <p><span className="font-medium">RCS :</span> Bordeaux B 948 801 808</p>
                    <p><span className="font-medium">Capital social :</span> 1 000 €</p>
                    <p><span className="font-medium">TVA intracommunautaire :</span> FR 91 948801808</p>
                  </div>
                  <Separator className="my-3" />
                  <div className="space-y-2 text-gray-700">
                    <p><span className="font-medium">Directeur de la publication :</span> Dominique Raynal</p>
                    <p><span className="font-medium">Responsable de la rédaction :</span> Dominique Raynal</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* 2. Hébergement du site */}
          <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-t-lg">
              <CardTitle className="flex items-center text-xl">
                <Globe className="h-6 w-6 mr-3" />
                2. Hébergement du site
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <div className="space-y-3">
                <h3 className="font-semibold text-lg text-green-700">OVH SAS</h3>
                <div className="grid md:grid-cols-2 gap-4 text-gray-700">
                  <div className="space-y-2">
                    <div className="flex items-start">
                      <MapPin className="h-4 w-4 mr-2 mt-1 text-green-600" />
                      <div>
                        <span className="font-medium">Adresse :</span><br />
                        2 rue Kellermann<br />
                        59100 Roubaix, France
                      </div>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center">
                      <Phone className="h-4 w-4 mr-2 text-green-600" />
                      <span><span className="font-medium">Téléphone :</span> 09 72 10 10 07</span>
                    </div>
                    <div className="flex items-center">
                      <Globe className="h-4 w-4 mr-2 text-green-600" />
                      <span><span className="font-medium">Site web :</span> www.ovh.com</span>
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* 3. Propriété intellectuelle */}
          <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-t-lg">
              <CardTitle className="flex items-center text-xl">
                <Shield className="h-6 w-6 mr-3" />
                3. Propriété intellectuelle
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6">
              <div className="space-y-4 text-gray-700">
                <p className="leading-relaxed">
                  L'ensemble du contenu du site (textes, images, logos, éléments graphiques, vidéos, structure, design…) 
                  est la propriété exclusive de <span className="font-semibold text-purple-700">Balinaisa</span>, sauf indication contraire.
                </p>
                <div className="bg-purple-50 border-l-4 border-purple-500 p-4 rounded-r-lg">
                  <p className="font-medium text-purple-800">
                    Toute reproduction, distribution, modification, adaptation ou publication, totale ou partielle, 
                    est strictement interdite sans l'accord écrit préalable de Balinaisa.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* 4. Données personnelles – RGPD */}
          <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white rounded-t-lg">
              <CardTitle className="flex items-center text-xl">
                <Shield className="h-6 w-6 mr-3" />
                4. Données personnelles – RGPD
              </CardTitle>
            </CardHeader>
            <CardContent className="p-6 space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-indigo-700 mb-3">Collecte des données</h4>
                  <p className="text-gray-700 mb-3">Balinaisa peut collecter des données personnelles lors de :</p>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      l'utilisation du formulaire de contact
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      l'inscription à une newsletter
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      la navigation sur le site (cookies)
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      échanges par email ou téléphone
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-indigo-700 mb-3">Responsable du traitement</h4>
                  <div className="bg-indigo-50 p-4 rounded-lg">
                    <p className="font-medium text-indigo-800">Balinaisa</p>
                    <p className="text-indigo-700">contact@balinaisa.com</p>
                  </div>
                </div>
              </div>

              <Separator />

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="font-semibold text-indigo-700 mb-3">Finalités du traitement</h4>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      gestion des demandes de contact
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      relation client
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      envoi d'informations ou d'offres commerciales (si consentement)
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full mr-3"></div>
                      analyse statistique du site
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-indigo-700 mb-3">Durée de conservation</h4>
                  <div className="bg-indigo-50 p-4 rounded-lg">
                    <p className="text-indigo-800">
                      Maximum <span className="font-semibold">3 ans</span> après le dernier contact 
                      ou la fin de la relation commerciale.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
                <h4 className="font-semibold text-blue-800 mb-2">Vos droits RGPD</h4>
                <p className="text-blue-700 mb-3">
                  Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits d'accès, 
                  rectification, suppression, opposition, limitation et portabilité de vos données.
                </p>
                <div className="flex items-center text-blue-800">
                  <Mail className="h-4 w-4 mr-2" />
                  <span className="font-medium">Pour exercer vos droits : contact@balinaisa.com</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-500">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;